import { getFilmById } from '@vista-digital/occ-domain'

export function getFilmHoCodeFromFilmId(filmId: string): string {
    const film = getFilmById(filmId)
    if (!film) return ''

    return film.hoCode
}
